import { getGraphSvg, GraphSvg } from '../../../utils/d3Utils.ts';
import { PreparedData } from '../prepare-data/prepareData.ts';


export function getRootElement(
    container: HTMLDivElement,
    { metaData }: PreparedData,
    drawBorder: boolean
): GraphSvg {
    const root = getGraphSvg(container);

    if (!drawBorder) {
        root.style('border', 'none');
    } else if (metaData.isLastValueFlagged) {
        root.style('border', '2px solid red');
    } else {
        root.style('border', '2px solid #aaa');
    }
    return root;
}
